import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface FinishedPlanIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function FinishedPlanIcon({
  color = RoutalPalette.secondary20,
  style = {},
  ...props
}: FinishedPlanIconProps) {
  const fillColor = style.color || color;
  return (
    <SvgIcon {...props} viewBox="0 0 12 12" style={{ height: `14px`, width: `14px`, ...style }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <g clipPath="url(#clip0_3394_25143)">
          <circle cx="8" cy="8.5" r="7.5" stroke={fillColor} />
          <path
            d="M4.70898 9.5124L6.2279 11.0313L11.291 5.96826"
            stroke={fillColor}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3394_25143">
            <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
